import React, {useEffect, useState} from "react";
import {Button, Form, Modal} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faExclamationCircle} from "@fortawesome/free-solid-svg-icons/faExclamationCircle";
import {faPlus} from "@fortawesome/free-solid-svg-icons/faPlus";
import ModalControls from "../../common/ModalControls";
import {useNavigate, useLocation} from "react-router-dom";
import {defaultFormState} from "../../../../defaults/Forms";
import {hiringStageDefault} from "../../../../defaults/Items";
import {
  onSaveAndClose,
  compareData,
  restoreFormData,
  onItemsListDeleteButtonClick,
  onCloseDetails, setForegroundColor
} from "../../../../helpers/ComponentHelper";

import AppComponentCardHeader from "../../common/AppComponentCardHeader";
import LoadingDataDiv from "../../common/LoadingDataDiv";
import DeleteWarningModal from "../../common/DeleteWarningModal";
import ItemDetailsModalHeader from "../../common/ItemDetailsModalHeader";
import TextInput from "../../../elements/TextInput";
import TextArea from "../../../elements/TextArea";
import useCrud from "../../../../hooks/useCrud";
import {Table} from "../../../table/Table";
import {faInfoCircle} from "@fortawesome/free-solid-svg-icons";
import Toggler from "../../../elements/Toggler";
import {HexColorPicker} from "react-colorful";

import "../../../../css/DictionaryForms.css";

const HiringStage = () => {

  const dataUrl = "/hiring-stages";
  const employeesUrl = "/employees";
  const relatedItemsUrl = null; // if no need to check it, initialize with null and remove RelatedItemsList from details modal
  const defaultItem = hiringStageDefault;
  const itemName = "etap zatrudnienia";
  const itemNames = "etapy zatrudnienia";
  const navigate = useNavigate();
  const location = useLocation();
  const {createItem, updateItem, deleteItem, getItems, getRelatedChildrenByParentId} = useCrud(dataUrl);

  const [loading, setLoading] = useState(true);
  const [allowDelete, setAllowDelete] = useState(null);
  const [currentFormState, setCurrentFormState] = useState(defaultFormState);
  const [itemsList, setItems] = useState([]);
  const [currentItem, setCurrentItem] = useState(defaultItem);
  const [backupItem, setBackupItem] = useState(defaultItem);
  const [itemChanged, setItemChanged] = useState(false);
  const [updateConflict, setUpdateConflict] = useState(false);
  const [conflictingRoles, setConflictingRoles] = useState(false);
  const [employeesList, setEmployeesList] = useState([]);
  const [conflictingRolesMsg, setConflictingRolesMsg] = useState("");
  const [itemColor, setItemColor] = useState("#ffffff");


  // elements related to current item
  const columns = [
    {label: "Id", accessor: "id", sortable: true, searchable: false},
    {label: "Nazwa", accessor: "name", sortable: true, searchable: true},
    {label: "Skrócona nazwa", accessor: "shortName", sortable: true, searchable: true},
    {label: "Opis", accessor: "description", sortable: true, searchable: true},
    {label: "Wymaga działu", accessor: "departmentRequired", sortable: true, searchable: false, type: "bool"},
    {label: "Wymaga stanowiska", accessor: "positionRequired", sortable: true, searchable: false, type: "bool"},
    {label: "Kolor etykiety", accessor: "color", sortable: false, searchable: false, type: "color"},
    {label: "Edycja", accessor: "editBtn", sortable: false, searchable: false},
    {label: "Usuń", accessor: "deleteBtn", sortable: false, searchable: false},
  ];


  const state = {
    itemsList, setItems,
    currentItem, setCurrentItem,
    currentFormState, setCurrentFormState,
    defaultItem, backupItem, setBackupItem, itemChanged, setItemChanged,
    setAllowDelete,
    setRelatedItems: null
  }


  const onDelete = async () => {
    const response = await deleteItem(`${dataUrl}/${currentItem.id}`, currentItem.id, state);
    if (response === 401 || response === 403) {
      navigate('/login', {state: {from: location}, replace: true});
    }
  }


  const onSaveItemClick = async (e) => {
    e.preventDefault();
    if (!currentItem.name || !currentItem.shortName) {
      if (!currentItem.name) {
        let nameInput = document.getElementById("name");
        nameInput.classList.add("form-input-invalid");
        nameInput.placeholder = `ten element jest wymagany`;
      }

      if (!currentItem.shortName) {
        let shortNameInput = document.getElementById("shortName");
        shortNameInput.classList.add("form-input-invalid");
        shortNameInput.placeholder = `ten element jest wymagany`;
      }
      return;
    }

    let response;
    const item = {
      id: currentItem.id,
      name: currentItem.name,
      shortName: currentItem.shortName,
      description: currentItem.description,
      color: currentItem.color,
      departmentRequired: !!currentItem.departmentRequired,
      positionRequired: !!currentItem.positionRequired
    };


    if (currentFormState.formAddingDataMode) {
      response = await createItem(dataUrl, item, state);
    } else {
      response = await updateItem(`${dataUrl}/${item.id}`, item, state);
    }

    if (response.status === 401 || response.status === 403) {
      navigate('/login', {state: {from: location}, replace: true});
    } else if (response.status === 409) {
      setUpdateConflict(true);
    } else {
      response && onSaveAndClose({state});
    }
  }


  const changeRequirement = (propertyName, checked) => {
    const nextItem = propertyName === "departmentRequired" && !checked
      ? {...currentItem, departmentRequired: false, positionRequired: false}
      : {...currentItem, [propertyName]: checked};
    setCurrentItem(nextItem);
    setItemChanged(!itemChanged);
    setCurrentFormState({...currentFormState, formSaveButtonDisabled: false});
  }


  const changeColor = (itemColor) => {
    setItemChanged(!itemChanged);
    setItemColor(itemColor)
    setCurrentItem({...currentItem,
      color: itemColor});
    setCurrentFormState({...currentFormState, formSaveButtonDisabled: false});
  }


  const checkRelatedItems = async (id) => {
    // const data = await getRelatedChildrenByParentId(`${ relatedItemsUrl }/${ id }`, id, setEventsList);
    // data.length === 0 ? setAllowDelete(true) : setAllowDelete(false);
    setAllowDelete(true);
  }


  const onClose = () => {
    setUpdateConflict(false);
    onCloseDetails({state});
  };


  useEffect(() => {
    if (updateConflict) setUpdateConflict(false);
    if (conflictingRoles) setConflictingRoles(false);
    compareData(currentFormState, setCurrentFormState, currentItem, backupItem);
  }, [itemChanged])


  useEffect(() => {
    if (allowDelete !== null) {
      onItemsListDeleteButtonClick(currentFormState, setCurrentFormState, itemName, allowDelete, currentItem.name);
    }
  }, [allowDelete])


  useEffect(() => {
    const getData = async () => {
      const [itemsData, employeesData] =
        await Promise.all([
          getItems(dataUrl),
          getItems(employeesUrl)
        ]);
      const success =
        itemsData.status === 200 &&
        employeesData.status === 200
      if (success) {
        setLoading(false);
        setItems(itemsData.data);
        setEmployeesList(employeesData.data);
      } else {
        alert("Nie udało się pobrać danych.");
      }
    };
    getData();
  }, [])


  const getCompleteItem = async (id) => {
    const response = await getItems(`${dataUrl}/${id}`);
    if (response.status === 200) {
      return response.data;
    } else if (response.status === 401 || response.status === 403) {
      navigate('/login', {state: {from: location}, replace: true})
    } else {
      alert("Nie udało się pobrać danych.");
    }
  }


  const addDataButtonProps = {
    setCurrentItem,
    setBackupItem,
    defaultItem,
    currentFormState,
    setCurrentFormState,
    formDescription: `Tu możesz dodać nowy element.`,
    formHeader: `Nowy element`,
    buttonTitle: ` Dodaj nowy Etap zatrudnienia`
  }


  let dataSectionContent;
  if (loading) {
    dataSectionContent = <LoadingDataDiv/>
  } else if (itemsList.length > 0) {
    dataSectionContent =
      <Table
        rows={itemsList}
        columns={columns}
        state={state}
        checkRelatedItems={checkRelatedItems}
        formHeader={`Edycja ${itemName}`}
        relatedItemsUrl={relatedItemsUrl}
        getCompleteItem={getCompleteItem}
      />
  } else {
    dataSectionContent =
      <div className={"warn_info"}><FontAwesomeIcon
        className={"warning-icon div-visible"} icon={faExclamationCircle}/>&nbsp;&nbsp;&nbsp;NIE ZNALEZIONO ŻADNYCH DANYCH
      </div>
  }


  const modalTitle = currentFormState.formAddingDataMode
    ? "Nowa pozycja: Etap zatrudnienia"
    : `Edycja: ${currentItem.name || "Etap zatrudnienia"}`;

  return (
    <div id="layoutSidenav_content" className="dictionary-page">
      <AppComponentCardHeader title="Pozycje słownika Etapy zatrudnienia" buttonProps={addDataButtonProps}/>

      <div className="container-fluid px-4 py-3">
        <div className={itemsList.length > 0 ? "card shadow p-1 mb-5 bg-white rounded-2" : "card shadow mb-5 bg-transparent rounded-2"}>
          {dataSectionContent}
        </div>
      </div>

      <Modal
        show={currentFormState.showForm}
        onHide={onClose}
        backdrop="static"
        keyboard={false}
        className="dictionary-form-modal"
        dialogClassName="dictionary-form-modal-dialog"
      >
        <Modal.Header closeButton>
          <Modal.Title>{modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="dictionary-form-intro">
            <div>
              <strong>{currentFormState.formAddingDataMode ? "Dodajesz nową pozycję słownika" : "Edytujesz istniejącą pozycję słownika"}</strong>
              <span>Uzupełnij pola poniżej. Pola oznaczone gwiazdką są wymagane.</span>
            </div>
            {!currentFormState.formAddingDataMode && (
              <Button size="sm" variant="outline-secondary" onClick={() => {
                setUpdateConflict(false);
                restoreFormData({state});
              }}>
                Przywróć wartości
              </Button>
            )}
          </div>

          <form id="add-hiring-stage-form" name="add-hiring-stage-form" className="dictionary-form-grid">
            <div className="dictionary-form-field">
              <label htmlFor="name"><span className="required">*</span> Nazwa</label>
              <TextInput propertyName="name" required={true} state={state}/>
              <small>Nazwa etapu widoczna na kartotece i liście pracowników.</small>
            </div>
            <div className="dictionary-form-field dictionary-form-field-short">
              <label htmlFor="shortName"><span className="required">*</span> Skrót</label>
              <TextInput propertyName="shortName" maxlen="10" required={true} state={state}/>
            </div>
            <div className="dictionary-form-field dictionary-form-field-full">
              <label htmlFor="description">Opis</label>
              <TextArea propertyName="description" required={false} rows="4" state={state}/>
            </div>
            <div className="dictionary-form-field dictionary-form-field-full">
              <label>Wymagania organizacyjne pracownika</label>
              <div className="d-flex flex-column gap-2 mt-1">
                <Form.Check
                  type="switch"
                  id="hiring-stage-department-required"
                  label="Podczas zapisu pracownika wymagaj działu"
                  checked={!!currentItem.departmentRequired}
                  onChange={event => changeRequirement("departmentRequired", event.target.checked)}
                />
                <Form.Check
                  type="switch"
                  id="hiring-stage-position-required"
                  label="Podczas zapisu pracownika wymagaj stanowiska"
                  checked={!!currentItem.positionRequired}
                  disabled={!currentItem.departmentRequired}
                  onChange={event => changeRequirement("positionRequired", event.target.checked)}
                />
              </div>
              <small>Stanowisko może być wymagane tylko wtedy, gdy wymagany jest również dział. Dział może być wymagany bez stanowiska.</small>
            </div>
            <div className="dictionary-form-field dictionary-form-field-full dictionary-form-color-field">
              <label>Kolor etykiety</label>
              <div className="dictionary-color-layout">
                <HexColorPicker color={currentItem.color || itemColor || "#ffffff"} onChange={changeColor}/>
                <span className="dictionary-color-preview" style={{"--dictionary-preview-color": currentItem.color || itemColor || "#ffffff"}}>
                  {currentItem.name || "Podgląd etykiety"}
                </span>
              </div>
            </div>
          </form>

          {updateConflict && (
            <div className="dictionary-form-error">
              <FontAwesomeIcon icon={faInfoCircle}/>
              <span>Nie można zapisać tej pozycji, ponieważ istnieje już wpis o tej nazwie lub skrócie.</span>
            </div>
          )}
        </Modal.Body>
        <ModalControls onDelete={onDelete} onCloseDetails={onClose} onSubmit={onSaveItemClick} state={state}/>
      </Modal>

      <DeleteWarningModal state={state} onDelete={onDelete} deleteItemName={itemName}/>
    </div>
  );

}

export default HiringStage;
